<ng-template #progressSpinnerRef>
    <div class="alternate-theme spinnerCenter">
        <mat-spinner mode="indeterminate" color="primary"></mat-spinner>
        <div class="loaderText">Loading...</div>
    </div>
</ng-template>
